import type { BaseValidation } from '@vuelidate/core';

type FormType<T> = Ref<BaseValidation<T>>;

export const useValidationHelpers = <T extends Record<string, any>>(form: FormType<T>) => {
  const hasError = (field: keyof T) => {
    return Boolean(form.value.$errors.find((error) => error.$property === field));
  };

  const fieldMessage = (field: keyof T): string | undefined => {
    const error = form.value.$errors.find((error) => error.$property === field);
    return error ? (error.$message as string) : undefined;
  };

  return {
    hasError,
    fieldMessage,
  };
};
